import classNames from "classnames";
import {
  useState,
  cloneElement,
  ReactElement,
  JSXElementConstructor,
} from "react";
import { Waypoint } from "react-waypoint";

interface Props {
  children: ReactElement<any, string | JSXElementConstructor<any>>;
  animationClassName?: string;
  duringDelayClassName?: string;
  onStartAnimation?: () => void;
  delay?: number;
  noAnimationDuringDelay?: boolean
}

export function AnimationOnAppear({
  children,
  animationClassName,
  duringDelayClassName,
  onStartAnimation,
  noAnimationDuringDelay,
  delay = 300,
}: Props) {
  const [isAnimating, startAnimate] = useState(false);

  const className = classNames(
    children!.props.className,
    isAnimating ? animationClassName : undefined,
    !noAnimationDuringDelay && delay && !isAnimating && (duringDelayClassName || "opacity-0")
  );

  const props = {
    className,
  };

  const handleRunAnimation = () => {
    setTimeout(() => {
      startAnimate(true);
      onStartAnimation?.();
    }, delay);
  };

  return (
    <Waypoint onEnter={handleRunAnimation}>
      {cloneElement(children, props)}
    </Waypoint>
  );
}
